var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPangolin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1302,
    viewBox: "0 0 1434 1302",
    width: 1434,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1303.06.302474-193.23-.151107 57.3 176.666633-364.018 264.055 288.188 209.626 342.1-248.18z",
    fill: "#ffc800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m266.041 176.213 57.381-176.061661-192.556-.151339-130.866 401.865 341.717 248.634 288.57-209.324z",
    fill: "#e1aa00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m683.586 212.952-292.425-212.725193-49.292 151.417193 341.717 248.634.151-.076v-187.401z",
    fill: "#e1aa00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m1042.24.453613-292.805 212.347387v187.401l341.945-248.028z",
    fill: "#ffc800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m342.549 729.496-.68 2.192 341.717 248.71.151-.152v-498.249z",
    fill: "#e1aa00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m1090.55 729.648-340.737-247.953-.378.302v498.249l341.945-248.028z",
    fill: "#ffc800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m683.511 1060-278.137-202.369-63.505 195.039 341.717 248.63.151-.15v-241.3z",
    fill: "#e1aa00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m1028.03 857.706-278.595 202.144v241.3l341.945-248.03z",
    fill: "#ffc800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPangolin);
export default __webpack_public_path__ + "static/media/pangolin.08f3dca9c317433dc20dca6ee554a622.svg";
export { ForwardRef as ReactComponent };